import axios from "axios";

// const ip = "localhost";
// const port = "3000";

const call = () =>
  axios.create({
    baseURL: `https://nutribit-backend.vercel.app/`
  });

const api = async ({ method, endpoint, body = undefined }) => {
  if (["GET", "POST", "DELETE", "PUT"].indexOf(method.toUpperCase()) === -1) {
    return;
  }

  const methodL = method.toLowerCase();

  // pretty much => axios.get(endpoint, data)
  return call()[methodL](endpoint, body);
};

export default api;
